/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ApikeysRouteImport } from './routes/apikeys'
import { Route as ChangelogRouteImport } from './routes/changelog'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as FundingRatesRouteImport } from './routes/funding-rates'
import { Route as LeaderboardRouteImport } from './routes/leaderboard'
import { Route as MpointsRouteImport } from './routes/mpoints'
import { Route as PointsRouteImport } from './routes/points'
import { Route as PortfolioRouteImport } from './routes/portfolio'
import { Route as ReferralsRouteImport } from './routes/referrals'
import { Route as TournamentRouteImport } from './routes/tournament'
import { Route as TradeRouteImport } from './routes/trade'
import { Route as XCallbackRouteImport } from './routes/x-callback'
import { Route as BuildersIndexRouteImport } from './routes/builders/index'
import { Route as BuildersDashboardRouteImport } from './routes/builders/dashboard'
import { Route as TournamentsIndexRouteImport } from './routes/tournaments/index'
import { Route as TournamentsSlugRouteImport } from './routes/tournaments/$slug'
import { Route as TradeMarketSymbolRouteImport } from './routes/trade/$marketSymbol'

const ApikeysRoute = ApikeysRouteImport.update({
  id: '/apikeys',
  path: '/apikeys',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangelogRoute = ChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const FundingRatesRoute = FundingRatesRouteImport.update({
  id: '/funding-rates',
  path: '/funding-rates',
  getParentRoute: () => rootRouteImport,
} as any)
const LeaderboardRoute = LeaderboardRouteImport.update({
  id: '/leaderboard',
  path: '/leaderboard',
  getParentRoute: () => rootRouteImport,
} as any)
const MpointsRoute = MpointsRouteImport.update({
  id: '/mpoints',
  path: '/mpoints',
  getParentRoute: () => rootRouteImport,
} as any)
const PointsRoute = PointsRouteImport.update({
  id: '/points',
  path: '/points',
  getParentRoute: () => rootRouteImport,
} as any)
const PortfolioRoute = PortfolioRouteImport.update({
  id: '/portfolio',
  path: '/portfolio',
  getParentRoute: () => rootRouteImport,
} as any)
const ReferralsRoute = ReferralsRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => rootRouteImport,
} as any)
const TournamentRoute = TournamentRouteImport.update({
  id: '/tournament',
  path: '/tournament',
  getParentRoute: () => rootRouteImport,
} as any)
const TradeRoute = TradeRouteImport.update({
  id: '/trade',
  path: '/trade',
  getParentRoute: () => rootRouteImport,
} as any)
const XCallbackRoute = XCallbackRouteImport.update({
  id: '/x-callback',
  path: '/x-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const BuildersIndexRoute = BuildersIndexRouteImport.update({
  id: '/builders/',
  path: '/builders/',
  getParentRoute: () => rootRouteImport,
} as any)
const BuildersDashboardRoute = BuildersDashboardRouteImport.update({
  id: '/builders/dashboard',
  path: '/builders/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const TournamentsIndexRoute = TournamentsIndexRouteImport.update({
  id: '/tournaments/',
  path: '/tournaments/',
  getParentRoute: () => rootRouteImport,
} as any)
const TournamentsSlugRoute = TournamentsSlugRouteImport.update({
  id: '/tournaments/$slug',
  path: '/tournaments/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const TradeMarketSymbolRoute = TradeMarketSymbolRouteImport.update({
  id: '/$marketSymbol',
  path: '/$marketSymbol',
  getParentRoute: () => TradeRoute,
} as any)

export interface FileRoutesByFullPath {
  '/apikeys': typeof ApikeysRoute
  '/changelog': typeof ChangelogRoute
  '/dashboard': typeof DashboardRoute
  '/funding-rates': typeof FundingRatesRoute
  '/leaderboard': typeof LeaderboardRoute
  '/mpoints': typeof MpointsRoute
  '/points': typeof PointsRoute
  '/portfolio': typeof PortfolioRoute
  '/referrals': typeof ReferralsRoute
  '/tournament': typeof TournamentRoute
  '/trade': typeof TradeRouteWithChildren
  '/x-callback': typeof XCallbackRoute
  '/builders/dashboard': typeof BuildersDashboardRoute
  '/tournaments/$slug': typeof TournamentsSlugRoute
  '/trade/$marketSymbol': typeof TradeMarketSymbolRoute
  '/builders/': typeof BuildersIndexRoute
  '/tournaments/': typeof TournamentsIndexRoute
}
export interface FileRoutesByTo {
  '/apikeys': typeof ApikeysRoute
  '/changelog': typeof ChangelogRoute
  '/dashboard': typeof DashboardRoute
  '/funding-rates': typeof FundingRatesRoute
  '/leaderboard': typeof LeaderboardRoute
  '/mpoints': typeof MpointsRoute
  '/points': typeof PointsRoute
  '/portfolio': typeof PortfolioRoute
  '/referrals': typeof ReferralsRoute
  '/tournament': typeof TournamentRoute
  '/trade': typeof TradeRouteWithChildren
  '/x-callback': typeof XCallbackRoute
  '/builders/dashboard': typeof BuildersDashboardRoute
  '/tournaments/$slug': typeof TournamentsSlugRoute
  '/trade/$marketSymbol': typeof TradeMarketSymbolRoute
  '/builders': typeof BuildersIndexRoute
  '/tournaments': typeof TournamentsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/apikeys': typeof ApikeysRoute
  '/changelog': typeof ChangelogRoute
  '/dashboard': typeof DashboardRoute
  '/funding-rates': typeof FundingRatesRoute
  '/leaderboard': typeof LeaderboardRoute
  '/mpoints': typeof MpointsRoute
  '/points': typeof PointsRoute
  '/portfolio': typeof PortfolioRoute
  '/referrals': typeof ReferralsRoute
  '/tournament': typeof TournamentRoute
  '/trade': typeof TradeRouteWithChildren
  '/x-callback': typeof XCallbackRoute
  '/builders/dashboard': typeof BuildersDashboardRoute
  '/tournaments/$slug': typeof TournamentsSlugRoute
  '/trade/$marketSymbol': typeof TradeMarketSymbolRoute
  '/builders/': typeof BuildersIndexRoute
  '/tournaments/': typeof TournamentsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/apikeys'
    | '/changelog'
    | '/dashboard'
    | '/funding-rates'
    | '/leaderboard'
    | '/mpoints'
    | '/points'
    | '/portfolio'
    | '/referrals'
    | '/tournament'
    | '/trade'
    | '/x-callback'
    | '/builders/dashboard'
    | '/tournaments/$slug'
    | '/trade/$marketSymbol'
    | '/builders/'
    | '/tournaments/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/apikeys'
    | '/changelog'
    | '/dashboard'
    | '/funding-rates'
    | '/leaderboard'
    | '/mpoints'
    | '/points'
    | '/portfolio'
    | '/referrals'
    | '/tournament'
    | '/trade'
    | '/x-callback'
    | '/builders/dashboard'
    | '/tournaments/$slug'
    | '/trade/$marketSymbol'
    | '/builders'
    | '/tournaments'
  id:
    | '__root__'
    | '/apikeys'
    | '/changelog'
    | '/dashboard'
    | '/funding-rates'
    | '/leaderboard'
    | '/mpoints'
    | '/points'
    | '/portfolio'
    | '/referrals'
    | '/tournament'
    | '/trade'
    | '/x-callback'
    | '/builders/dashboard'
    | '/tournaments/$slug'
    | '/trade/$marketSymbol'
    | '/builders/'
    | '/tournaments/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ApikeysRoute: typeof ApikeysRoute
  ChangelogRoute: typeof ChangelogRoute
  DashboardRoute: typeof DashboardRoute
  FundingRatesRoute: typeof FundingRatesRoute
  LeaderboardRoute: typeof LeaderboardRoute
  MpointsRoute: typeof MpointsRoute
  PointsRoute: typeof PointsRoute
  PortfolioRoute: typeof PortfolioRoute
  ReferralsRoute: typeof ReferralsRoute
  TournamentRoute: typeof TournamentRoute
  TradeRoute: typeof TradeRouteWithChildren
  XCallbackRoute: typeof XCallbackRoute
  BuildersDashboardRoute: typeof BuildersDashboardRoute
  TournamentsSlugRoute: typeof TournamentsSlugRoute
  BuildersIndexRoute: typeof BuildersIndexRoute
  TournamentsIndexRoute: typeof TournamentsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/apikeys': {
      id: '/apikeys'
      path: '/apikeys'
      fullPath: '/apikeys'
      preLoaderRoute: typeof ApikeysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/changelog': {
      id: '/changelog'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof ChangelogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/funding-rates': {
      id: '/funding-rates'
      path: '/funding-rates'
      fullPath: '/funding-rates'
      preLoaderRoute: typeof FundingRatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/leaderboard': {
      id: '/leaderboard'
      path: '/leaderboard'
      fullPath: '/leaderboard'
      preLoaderRoute: typeof LeaderboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mpoints': {
      id: '/mpoints'
      path: '/mpoints'
      fullPath: '/mpoints'
      preLoaderRoute: typeof MpointsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/points': {
      id: '/points'
      path: '/points'
      fullPath: '/points'
      preLoaderRoute: typeof PointsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portfolio': {
      id: '/portfolio'
      path: '/portfolio'
      fullPath: '/portfolio'
      preLoaderRoute: typeof PortfolioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/referrals': {
      id: '/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof ReferralsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tournament': {
      id: '/tournament'
      path: '/tournament'
      fullPath: '/tournament'
      preLoaderRoute: typeof TournamentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trade': {
      id: '/trade'
      path: '/trade'
      fullPath: '/trade'
      preLoaderRoute: typeof TradeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/x-callback': {
      id: '/x-callback'
      path: '/x-callback'
      fullPath: '/x-callback'
      preLoaderRoute: typeof XCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/builders/': {
      id: '/builders/'
      path: '/builders'
      fullPath: '/builders/'
      preLoaderRoute: typeof BuildersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/builders/dashboard': {
      id: '/builders/dashboard'
      path: '/builders/dashboard'
      fullPath: '/builders/dashboard'
      preLoaderRoute: typeof BuildersDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tournaments/': {
      id: '/tournaments/'
      path: '/tournaments'
      fullPath: '/tournaments/'
      preLoaderRoute: typeof TournamentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tournaments/$slug': {
      id: '/tournaments/$slug'
      path: '/tournaments/$slug'
      fullPath: '/tournaments/$slug'
      preLoaderRoute: typeof TournamentsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trade/$marketSymbol': {
      id: '/trade/$marketSymbol'
      path: '/$marketSymbol'
      fullPath: '/trade/$marketSymbol'
      preLoaderRoute: typeof TradeMarketSymbolRouteImport
      parentRoute: typeof TradeRoute
    }
  }
}

interface TradeRouteChildren {
  TradeMarketSymbolRoute: typeof TradeMarketSymbolRoute
}

const TradeRouteChildren: TradeRouteChildren = {
  TradeMarketSymbolRoute: TradeMarketSymbolRoute,
}

const TradeRouteWithChildren = TradeRoute._addFileChildren(TradeRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  ApikeysRoute: ApikeysRoute,
  ChangelogRoute: ChangelogRoute,
  DashboardRoute: DashboardRoute,
  FundingRatesRoute: FundingRatesRoute,
  LeaderboardRoute: LeaderboardRoute,
  MpointsRoute: MpointsRoute,
  PointsRoute: PointsRoute,
  PortfolioRoute: PortfolioRoute,
  ReferralsRoute: ReferralsRoute,
  TournamentRoute: TournamentRoute,
  TradeRoute: TradeRouteWithChildren,
  XCallbackRoute: XCallbackRoute,
  BuildersDashboardRoute: BuildersDashboardRoute,
  TournamentsSlugRoute: TournamentsSlugRoute,
  BuildersIndexRoute: BuildersIndexRoute,
  TournamentsIndexRoute: TournamentsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
